import React, { useEffect, useMemo, useState } from 'react';
import styles from './DocumentPageData.module.scss';
import Pagination from './components/pagination';
import http from 'app/http';
import qs from 'qs';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { setContent } from 'features/content/reducer';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import {MimeTypesForExtension} from 'common/consts/MimeTypesForExtension';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}
const DocumentPageData = (props: any) => {
  const { Model, PageData, LayoutModel } = props;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [current, setCurrent] = useState<number>(1);
  const [rowsPerPageCount, setRowsPerPageCount] = useState<number>(Model.NoOfRowsPerPage);
  const [totalRowsCount, setTotalRowsCount] = useState<number>(Model.TotalRows);
  const [posts,setposts]=useState<any>(Model.DocumentDetails);  
  const [currentPage, setCurrentPage] = useState(1);
  const [isDesc, setIsDesc] = useState<boolean>(true);
  const [isDescCaseCode, setIsDescCaseCode] = useState<boolean>(false);

  
  const indexLastItem = currentPage * rowsPerPageCount;
  const indexFirstItem = indexLastItem - rowsPerPageCount;
   let currentList = posts.slice(indexFirstItem, indexLastItem);
 
  const numberOfPages = Math.ceil(totalRowsCount / rowsPerPageCount);
  
      const onSortDate = (sortList:any) => {
        let unsortedlist =[...sortList];
             
        const latestData = unsortedlist.sort((a:any, b:any) => {
        const dateStringA =a.DocumentDate.split("/").reverse().join("-");
        const dateStringB= b.DocumentDate.split("/").reverse().join("-");
          if(isDesc){
                      
              if (dateStringA < dateStringB) {
                return -1;
              } else if (dateStringA > dateStringB) {
                return 1;
              }              
              return 0;
             
            }
            else{
              
              if (dateStringB < dateStringA) {
                return -1;
              } else if (dateStringB > dateStringA) {
                return 1;
              }              
              return 0;
             
            }
          }                
        );
        if(isDesc)
        {
          setIsDesc(false);
        }
        else{
          setIsDesc(true);
        }
        setposts(latestData);        
        };

        const onSortCaseCode = (sortList:any) => {
          let unsortedlist =[...sortList];
               
          const latestData = unsortedlist.sort((a:any, b:any) => {
          const  elementA =((a.CaseCode != null) &&(a.CaseCode !== '') && !isNaN(Number(a.CaseCode.toString()))) ? Number(a.CaseCode) : 0;
          const  elementB= ((b.CaseCode != null) &&(b.CaseCode !== '') && !isNaN(Number(b.CaseCode.toString()))) ? Number(b.CaseCode) : 0;          
            if(isDescCaseCode){
                        
                if (elementA < elementB) {
                  return -1;
                } else if (elementA > elementB) {
                  return 1;
                }              
                return 0;
               
              }
              else{
                
                if (elementB < elementA) {
                  return -1;
                } else if (elementB > elementA) {
                  return 1;
                }              
                return 0;
               
              }
            }                
          );
          if(isDescCaseCode)
          {
            setIsDescCaseCode(false);
          }
          else{
            setIsDescCaseCode(true);
          }
          setposts(latestData);        
          };
    
  async function DownloadPdf(base64:any,filename:string, documentId:string ){  
    let linkSource = '';
    
    if(filename.includes('.'))
    {
      let extension = filename.split('.').pop();
      let extensionWithDot = '.' + extension?.toLowerCase();
      let mimeType = 'application/octet-stream'
      Object.entries(MimeTypesForExtension).map(([key, value]) => {  
        if(key === extensionWithDot )
        {
          mimeType = value;
        }
        });            
      linkSource = `data:${mimeType};base64,${base64}`;
      const blobResponse = await fetch(linkSource);  
      const blobFromFetch= await blobResponse.blob();
      const blobType = blobFromFetch.type;
      var blob = new Blob([blobFromFetch], {type: blobType});
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");      
    }
    else
    {
      let name = '';
      if(!filename)
      {
        name = documentId;
      }
      else{
        name = filename;
      }
      linkSource = `data:application/octet-stream;base64,${base64}`; 
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = name;
      downloadLink.click();
    }
        
  }

  async function Downloadfile(documentId: any,profileId: any) {
    const response = await http.post(
      Model.DownloadUrl,
      // Convert object into string
      qs.stringify({
        'FormModel.ProfileId':
        profileId,
        'FormModel.DocumentId': documentId,
      }),
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
    if (response && response.data) {
      var nextPagePath = '';
      if (!response.data.RedirectUrl) {      
        var fileName = response.data.fileName;
        var fileContent = response.data.fileContent;
        await DownloadPdf(fileContent, fileName,documentId)        
      } else {
        nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        // Redirect to next step path
      history.push(nextPagePath, {
        noRefresh: false,
      });

      }      
    }  
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className={styles.tablewrapper}>
          <div className={styles.headRow}>
          <button className={classNames(
                      styles.label,
                    
                      styles.active, // Display chevron
                      !isDescCaseCode && styles.asc, // Rotate chevron
                    )}  onClick={() => onSortCaseCode(posts)}>{PageData?.CaseCode}</button>
            <button className={styles.label}>{PageData?.Description}</button>
            <button className={classNames(
                      styles.label,
                    
                      styles.active, // Display chevron
                      !isDesc && styles.asc, // Rotate chevron
                    )}  onClick={() => onSortDate(posts)}>{PageData?.DocumentDate}</button>

            
          </div>
          {(currentList || []).map(
            (postsitem:any )=>
              ( <div className={styles.Row } onClick={(e) => Downloadfile(postsitem?.DocumentId,
                Model?.ProfileId)}>
                <div className={styles.column}>{postsitem?.CaseCode}</div>                
                <div className={styles.column}>{postsitem?.DocumentDescription}</div>
                <div className={styles.column}>{postsitem?.DocumentDate}</div>
              </div>),
          )}
          
        </div>

        <div className={styles.footer}>
          <Pagination
            currentPage={currentPage}
            numberOfPages={numberOfPages}
            lengthpage={posts.length}
           
            onChange={(index) => setCurrentPage(index)}
          
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentPageData;
